import { useRef } from "react";
import { Camera, X } from "lucide-react";
import { SectionLabel } from "./ui";

/** Pre-submit photo picker for the Raise Complaint form — files are held in
 * memory (File[]) and uploaded to the ticket only after it's created. */
export default function CustomerPhotoPicker({ files, onChange }) {
  const inputRef = useRef(null);

  function addFiles(e) {
    const picked = Array.from(e.target.files || []);
    if (!picked.length) return;
    onChange([...files, ...picked].slice(0, 6));
    if (inputRef.current) inputRef.current.value = "";
  }

  function removeAt(i) {
    onChange(files.filter((_, idx) => idx !== i));
  }

  return (
    <div>
      <SectionLabel className="mb-2 flex items-center gap-1.5">
        <Camera className="w-3 h-3" /> Add photos <span className="text-slate-400">(optional, up to 6)</span>
      </SectionLabel>
      <div className="flex flex-wrap gap-2">
        {files.map((f, i) => (
          <div key={i} className="relative w-16 h-16 rounded-xl overflow-hidden border border-slate-200 bg-slate-100" data-testid={`complaint-photo-preview-${i}`}>
            <img src={URL.createObjectURL(f)} alt={`Attachment ${i + 1}`} className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => removeAt(i)}
              data-testid={`complaint-photo-remove-${i}`}
              className="absolute top-0.5 right-0.5 bg-black/60 text-white rounded-full p-0.5"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}
        {files.length < 6 && (
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            data-testid="complaint-photo-add-btn"
            className="w-16 h-16 rounded-xl border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400 hover:border-emerald-400 hover:text-emerald-600"
          >
            <Camera className="w-4.5 h-4.5" />
            <span className="text-[9px] font-semibold mt-0.5">Add</span>
          </button>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        multiple
        onChange={addFiles}
        className="hidden"
        data-testid="complaint-photo-input"
      />
    </div>
  );
}
